"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const KeyboardEventCodeEnum_1 = __importDefault(require("@cmd/KeyboardEventCodeEnum"));
const Dropdown = (DropdownComponent) => {
    const EnhancedDropdownComponent = (props) => {
        const [isOpen, setIsOpen] = (0, react_1.useState)(false);
        const dropdownRef = (0, react_1.useRef)(null);
        const toggleDropdown = () => setIsOpen((prev) => !prev);
        const handleClickOutside = (event) => {
            if (dropdownRef.current !== null && dropdownRef.current.contains(event.target) === false) {
                setIsOpen(false);
            }
        };
        const handleKeyDown = (event) => {
            if (event.code === KeyboardEventCodeEnum_1.default.ESCAPE) {
                setIsOpen(false);
            }
        };
        (0, react_1.useEffect)(() => {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('keydown', handleKeyDown);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
                document.removeEventListener('keydown', handleKeyDown);
            };
        }, []);
        return react_1.default.createElement("div", { ref: dropdownRef, onClick: toggleDropdown },
            react_1.default.createElement(DropdownComponent, Object.assign({}, props, { isOpen: isOpen })));
    };
    return EnhancedDropdownComponent;
};
exports.default = Dropdown;
